import { render } from "./SupplierCategoryDialog.vue?vue&type=template&id=284338ee&scoped=true"
import script from "./SupplierCategoryDialog.vue?vue&type=script&lang=js"
export * from "./SupplierCategoryDialog.vue?vue&type=script&lang=js"

import "./SupplierCategoryDialog.vue?vue&type=style&index=0&id=284338ee&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284338ee"]])

export default __exports__